import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"left\"><path fill=\"currentColor\" d=\"M18.89 2.53L9.42 12l9.47 9.47L16.36 24 5.63 13.26a1.77 1.77 0 0 1 0-2.52L16.36 0z\" data-name=\"Icons-/-Large-/-Primary-/-Up\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol